//#region imports
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
//#endregion

const routes: Routes = [
  {
    path: 'characteristics',
    loadChildren: () => import('./module/characteristics/characteristics.module').then(m => m.CharacteristicsModule)
  },
  {
    path: 'details',
    loadChildren: () => import('./module/details/details.module').then(m => m.DetailsModule)
  },
  {
    path: 'guarantee',
    loadChildren: () => import('./module/guarantee/guarantee.module').then(m => m.GuaranteeModule)
  },
  {
    path: 'recapitulatory',
    loadChildren: () => import('./module/recapitulatory/recapitulatory.module').then(m => m.RecapitulatoryModule)
  },
  {
    path: 'signature',
    loadChildren: () => import('./module/signature/signature.module').then(m => m.SignatureModule)
  },
  { path: '', redirectTo: 'characteristics', pathMatch: 'full' },
  { path: '**', redirectTo: 'characteristics', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    CarouselModule.forRoot(),
    ProgressbarModule.forRoot(),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
